<template>
  <div class="class-charts">
    <!-- 各模块得分情况 -->

    <div class="canvas-box" ref="myTotalTable" style="width: 415px;height: 200px;"></div>
  </div>
</template>
<script>

export default {
  props: ["model"],
  data() {
    return {
      avg: [],
      max:[],
      min:[],
      score:[],
      name: [],
      placeholder:[],
      
    };
  },
  mounted() {
    if (this.model) {
      this.renderMap();
    }
  },
  watch: {
    model(val) {
      if (val) {
        this.renderMap();
      }
    },
  },
  methods: {
    renderMap() {
      this.model.map((item) => {
        this.avg.push(item.avg);
        this.score.push(item.score);
        this.max.push(item.max);
        this.min.push(item.min);
        this.name.push(item.name);
        this.placeholder.push(item.max - item.min);
      });
      let myTotalTable = (window.cc = this.$echarts.init(
        this.$refs["myTotalTable"]
      ));
      let zhetuStyle = [
        {
          text: "1.0",
          width: 30,
          height: 65,
          fill: "#4288D5",
          shadowColor: "#4288D5",
          fontWeight: "bold",
        },
        {
          text: "2.0",
          width: 30,
          height: 65,
          fill: "#4288D5",
          shadowColor: "#4288D5",
          fontWeight: "bold",
        },
        {
          text: "3.0",
          width: 30,
          height: 65,
          fill: "#4288D5",
          shadowColor: "#4288D5",
          fontWeight: "bold",
        },
        {
          text: "4.0",
          width: 30,
          height: 65,
          fill: "#4288D5",
          shadowColor: "#4288D5",
          fontWeight: "bold",
        },
        {
          text: "5.0",
          width: 30,
          height: 65,
          fill: "#4288D5",
          shadowColor: "#4288D5",
          fontWeight: "bold",
        },
        {
          text: "6.0",
          width: 30,
          height: 65,
          fill: "#4288D5",
          shadowColor: "#4288D5",
          fontWeight: "bold",
        },
        {
          text: "7.0",
          width: 30,
          height: 65,
          fill: "#4288D5",
          shadowColor: "#4288D5",
          fontWeight: "bold",
        },
        {
          text: "8.0",
          width: 30,
          height: 65,
          fill: "#4288D5",
          shadowColor: "#4288D5",
          fontWeight: "bold",
        },
        {
          text: "9.0",
          width: 30,
          height: 65,
          fill: "#4288D5",
          shadowColor: "#4288D5",
          fontWeight: "bold",
        },
        {
          text: "10.0",
          width: 30,
          height: 65,
          fill: "#4288D5",
          shadowColor: "#4288D5",
          fontWeight: "bold",
        },
      ];
      let option = {
        animation: false,
        tooltip: {
          show: false,
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            crossStyle: {
              color: "#00A6E5",
            },
          },
        },
        legend: {
          data: ["平均分", "得分"],
        },
        grid: {
          left: "-2px",
          right: "0%",
          top: "40px",
        },
        height:166,
        xAxis: {
          position: "top",
          axisTick: { show: false }, // 刻度
          type: "value",
          min: 1.0,
          max: 10.0,
          interval: 1,
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#4288D5"],
              width: 0.5,
              type: "solid",
            },
          },
        },
        yAxis: [
          {
            type: "category",
            show: false,
            data: this.name,
            axisPointer: {
              type: "shadow",
            },
          },
          {
            type: "value",
            min: 0,
            axisTick: { show: false }, // 刻度
            max: 4,
            interval: 1,
            axisLabel: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#4288D5"],
                width: 0.5,
                type: "solid",
              },
            },
          },
        ],
        graphic: {
          elements: [
            {
              type: "text",
              zlevel: 10,
              left: 0,
              top: 20,
              style: zhetuStyle[0],
            },
            {
              type: "text",
              zlevel: 10,
              left: 40,
              top: 20,
              style: zhetuStyle[1],
            },
            {
              type: "text",
              zlevel: 10,
              left: 80,
              top: 20,
              style: zhetuStyle[2],
            },
            {
              type: "text",
              zlevel: 10,
              left: 130,
              top: 20,
              style: zhetuStyle[3],
            },
            {
              type: "text",
              zlevel: 10,
              left: 173,
              top: 20,
              style: zhetuStyle[4],
            },
            {
              type: "text",
              zlevel: 10,
              left: 220,
              top: 20,
              style: zhetuStyle[5],
            },
            {
              type: "text",
              zlevel: 10,
              left: 265,
              top: 20,
              style: zhetuStyle[6],
            },
            {
              type: "text",
              zlevel: 10,
              left: 310,
              top: 20,
              style: zhetuStyle[7],
            },
            {
              type: "text",
              zlevel: 10,
              left: 355,
              top: 20,
              style: zhetuStyle[8],
            },
            {
              type: "text",
              zlevel: 10,
              left: 388,
              top: 20,
              style: zhetuStyle[9],
            },
          ],
        },
        series: [
          {
            type: "bar",
            stack: "Total",
            itemStyle: {
              borderColor: "transparent",
              color: "transparent",
            },

            emphasis: {
              itemStyle: {
                borderColor: "总监级以下",
                color: "transparent",
              },
            },
            barWidth:25,
            label: {
              // show: true,
              position: "inside",
            },
            data: this.min.reverse()
          },
          {
            name: "区间跨度",
            type: "bar",
            stack: "Total",
            itemStyle: {
              borderColor: "transparent",
              color: "#61A8FF",
              // barBorderRadius: [15, 15, 15, 15],
            },
            label: {
              show: false,
              position: "inside",
            },
            data:this.placeholder.reverse()
          },
          {
            type: "bar",
            stack: "Total",
            itemStyle: {
              borderColor: "transparent",
              color: "transparent",
            },
            emphasis: {
              itemStyle: {
                borderColor: "transparent",
                color: "transparent",
              },
            },
            data: this.max.reverse(),
          },
          {
            name: "平均分",
            type: "line",
            symbolSize: 8,
            symbol: "dotted",
            smooth: true,
            itemStyle: {
              normal: {
                color: "#0039FF",
                borderColor: '#0039FF',
                borderWidth: 2,
              },
            },

            lineStyle: {
              width: 3,
              color: "#0039FF",
            },
            data: this.avg.reverse(),
          },
          {
            name: "得分",
            type: "line",
            symbolSize: 8,
            symbol: "dotted",

            smooth: true,
             itemStyle: {
              normal: {
                color: "#FF2468",
                borderColor: '#FF2468',
                borderWidth: 2,
              },
            },
            lineStyle: {
              width: 2,
              color: "#FF2468",
            },
            data: this.score.reverse(),
          },
        ],
      };
      myTotalTable.setOption(option);
    },
  },
};
</script>
<style lang="scss" scoped>
.class-charts {
  display: inline-block;
  .canvas-box {
    // margin: 10px auto 10px;
    // width: 415px;
    // height: 200px;
    margin:0px 0px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dataView/echarts/four/capability1.vue